import "./Styles/SignupPage.css";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { toast } from "react-toastify";
import { registerUser } from "../redux/apiCall/authCall";
import { Link, useNavigate } from "react-router-dom";
import {
  isValidPassword,
  PASSWORD_REQUIREMENTS_MESSAGE,
} from "../utils/passwordValidation";
import {
  isValidPhone,
  normalizePhone,
  PHONE_REQUIREMENTS_MESSAGE,
} from "../utils/phoneValidation";
import ButtonComponent from "../components/ButtonComponent";
import {
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBRow,
  MDBCol,
  MDBInput,
} from "mdb-react-ui-kit";
import Logo from "../assets/log.png";
import adminLogo from "../assets/bandaliiii.jpg";

const SignupPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    username: "",
    password: "",
  });
  const [verifyPassword, setVerifyPassword] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});

  const setFieldError = (field, message) => {
    setFieldErrors((prev) => ({ ...prev, [field]: message }));
  };

  const clearFieldError = (field) => {
    setFieldErrors((prev) => {
      const next = { ...prev };
      delete next[field];
      return next;
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let nextValue = value;

    if (name === "phone") {
      nextValue = value.replace(/[^\d+]/g, "");
    }

    setFormData((prev) => ({ ...prev, [name]: nextValue }));

    if (name === "password") {
      if (nextValue && !isValidPassword(nextValue)) {
        setFieldError("password", PASSWORD_REQUIREMENTS_MESSAGE);
      } else {
        clearFieldError("password");
      }
    }

    if (name === "phone") {
      if (nextValue && !isValidPhone(nextValue)) {
        setFieldError("phone", PHONE_REQUIREMENTS_MESSAGE);
      } else {
        clearFieldError("phone");
      }
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    if (name === "password") {
      if (!value.trim()) {
        setFieldError("password", "Password is required.");
      } else if (!isValidPassword(value)) {
        setFieldError("password", PASSWORD_REQUIREMENTS_MESSAGE);
      }
    }

    if (name === "phone") {
      if (!value.trim()) {
        setFieldError("phone", "Phone number is required.");
      } else if (!isValidPhone(value)) {
        setFieldError("phone", PHONE_REQUIREMENTS_MESSAGE);
      }
    }

    if (name === "verifyPassword") {
      if (!value.trim()) {
        setFieldError("verifyPassword", "Please confirm your password.");
      } else if (formData.password !== value) {
        setFieldError("verifyPassword", "Passwords do not match.");
      }
    }
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.firstName.trim()) errors.firstName = "First name is required.";
    if (!formData.lastName.trim()) errors.lastName = "Last name is required.";
    if (!formData.phone.trim()) {
      errors.phone = "Phone number is required.";
    } else if (!isValidPhone(formData.phone)) {
      errors.phone = PHONE_REQUIREMENTS_MESSAGE;
    }
    if (!formData.email.trim()) errors.email = "Email is required.";
    if (!formData.username.trim()) errors.username = "Username is required.";
    if (!formData.password.trim()) {
      errors.password = "Password is required.";
    } else if (!isValidPassword(formData.password)) {
      errors.password = PASSWORD_REQUIREMENTS_MESSAGE;
    }
    if (!verifyPassword.trim()) {
      errors.verifyPassword = "Please confirm your password.";
    } else if (formData.password !== verifyPassword) {
      errors.verifyPassword = "Passwords do not match.";
    }

    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error("Please fix the errors below.");
      return;
    }

    const result = await dispatch(
      registerUser({
        ...formData,
        firstName: formData.firstName.trim(),
        lastName: formData.lastName.trim(),
        username: formData.username.trim(),
        email: formData.email.trim().toLowerCase(),
        phone: normalizePhone(formData.phone),
      })
    );

    if (result?.success) {
      navigate("/login", {
        state: {
          email: formData.email.trim().toLowerCase(),
          signupSuccess: true,
        },
      });
      return;
    }

    if (result?.field && result?.message) {
      setFieldError(result.field, result.message);
    }
  };

  const renderError = (field) =>
    fieldErrors[field] ? (
      <p className="signup-field-error">{fieldErrors[field]}</p>
    ) : null;

  return (
    <MDBContainer className="my-5 margin-zero-auto signup-auth-page">
      <MDBCard>
        <MDBRow className="g-0">
          <MDBCol md="3">
            <img
              src={adminLogo}
              alt="login form"
              className="rounded-start img-login-admin-user w-100"
            />
          </MDBCol>

          <MDBCol md="3">
            <MDBCardBody className="d-flex flex-column">
              <div className="d-flex flex-row mt-2">
                <img alt="logo-img" className="logo" src={Logo} width={328} height={58} />
              </div>
              <div className="inputs-for-singup">
                <MDBInput
                  wrapperClass="mb-2"
                  type="text"
                  name="firstName"
                  required
                  size="sm"
                  className="input-input-input"
                  placeholder="Enter your first name"
                  value={formData.firstName}
                  onChange={handleChange}
                />
                {renderError("firstName")}

                <MDBInput
                  wrapperClass="mb-2 mt-3"
                  type="text"
                  name="lastName"
                  className="input-input-input"
                  size="sm"
                  placeholder="Enter your last name"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
                {renderError("lastName")}

                <MDBInput
                  wrapperClass="mb-2 mt-3"
                  type="text"
                  name="username"
                  className="input-input-input"
                  size="sm"
                  placeholder="Enter your username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                />
                {renderError("username")}

                <MDBInput
                  wrapperClass="mb-2 mt-3"
                  type="tel"
                  className="input-input-input"
                  size="sm"
                  name="phone"
                  placeholder="Enter your phone number"
                  value={formData.phone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                />
                <p className="signup-field-hint">{PHONE_REQUIREMENTS_MESSAGE}</p>
                {renderError("phone")}
              </div>
            </MDBCardBody>
          </MDBCol>

          <MDBCol md="4" py="5">
            <MDBCardBody className="d-flex flex-column">
              <div className="inputs-for-singup2">
                <MDBInput
                  wrapperClass="mb-2"
                  type="email"
                  className="input-input-input"
                  size="sm"
                  name="email"
                  placeholder="Enter your email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                {renderError("email")}

                <MDBInput
                  wrapperClass="mb-2 mt-3"
                  type="password"
                  className="input-input-input"
                  size="sm"
                  name="password"
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                />
                <p className="signup-field-hint">{PASSWORD_REQUIREMENTS_MESSAGE}</p>
                {renderError("password")}

                <MDBInput
                  wrapperClass="mb-2 mt-3"
                  type="password"
                  className="input-input-input"
                  size="sm"
                  name="verifyPassword"
                  placeholder="Verify your password"
                  value={verifyPassword}
                  onChange={(e) => {
                    setVerifyPassword(e.target.value);
                    clearFieldError("verifyPassword");
                  }}
                  onBlur={handleBlur}
                  required
                />
                {renderError("verifyPassword")}

                <ButtonComponent
                  type="button"
                  onClick={handleSubmit}
                  className="btn btn-primary btn-block mt-3"
                >
                  Sign Up
                </ButtonComponent>
                <div className="signup-main-container-span d-flex align-items-left mt-3 ml-2">
                  <p className="fs-5 signup-main-container-form-text">
                    Already a member?
                    <span className="signup-main-container-span">
                      <Link to="/login">&nbsp;Log in now</Link>
                    </span>
                  </p>
                </div>
              </div>
            </MDBCardBody>
          </MDBCol>
        </MDBRow>
      </MDBCard>
    </MDBContainer>
  );
};

export default SignupPage;
